import React from "react";
import "./shared.css";

export default function Card({ children, className = "", hoverable = false, style, ...props }) {
  return (
    <div
      className={`card-shared ${hoverable ? "card-hoverable" : ""} ${className}`}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}
